module.exports = "<div class=\"file-count\">\n  {{fileCount + (fileCount > 1 ? \" RESULTS FOR\" : \" RESULT FOR\")}}\n</div>\n<div class=\"search-text\">\n  {{searchText}}\n</div>\n\n\n\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/search-info/search-info.component.html
// module id = ./src/app/shared/components/search-info/search-info.component.html
// module chunks = main